 function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import {useEffect, useRef} from 'react'











const safeDuration = (audio) => {
  const duration = _optionalChain([audio, 'optionalAccess', _ => _.duration])
  if (duration && isFinite(duration)) return duration
  return 0
}

const useSoundEffect = (props) => {
  // avoid playing when navigating to a page when the timer is already up.
  const hasPlayed = useRef(false)
  const soundRef = useRef(null)

  const end =
    props.startTime !== undefined
      ? new Date(props.startTime).valueOf()
      : new Date(props.endTime).valueOf() - safeDuration(soundRef.current) * 1000
  const now = new Date().valueOf()
  const isTimeUp = end <= now

  useEffect(() => {
    hasPlayed.current = isTimeUp
  }, [])

  useEffect(() => {
    if (isTimeUp && !hasPlayed.current) {
      _optionalChain([soundRef, 'access', _2 => _2.current, 'optionalAccess', _3 => _3.play, 'call', _4 => _4(), 'access', _5 => _5.catch, 'call', _6 => _6(() => {
        // ignore, can happen if the user did not interact with the page first
      })])
      hasPlayed.current = true
    }
    if (!isTimeUp) {
      hasPlayed.current = false
      // stop playback if we just added time
      if (soundRef.current && !soundRef.current.paused) {
        soundRef.current.pause()
        soundRef.current.currentTime = 0
      }
    }
  }, [isTimeUp])
  return soundRef
}

export default useSoundEffect
